/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The focus/interest a user has when consuming their report
 * @export
 * @enum {string}
 */

export const ManagementFocus = {
    TeamLead: 'TEAM_LEAD',
    ManagerOfManagers: 'MANAGER_OF_MANAGERS',
    Executive: 'EXECUTIVE',
    PeopleAdvisor: 'PEOPLE_ADVISOR',
    PeopleExecutive: 'PEOPLE_EXECUTIVE',
    AccountAdmin: 'ACCOUNT_ADMIN',
    Generic: 'GENERIC'
} as const;

export type ManagementFocus = typeof ManagementFocus[keyof typeof ManagementFocus];



